import { action, computed } from 'mobx';
import moment, { type Moment } from 'moment';
import { Entity, PaymentGatewayType } from '../..';

export default class StudentPaymentMethod extends Entity {
    constructor(t?: Partial<StudentPaymentMethod>) {
        super(t);
        if (t) this.update(t);
    }

    createdDate: Moment;
    updatedDate: Moment | null = null;
    cardFirstSixDigits: string | null = null;
    cardLastFourDigits: string | null = null;
    cardExpMonth: number | null = null;
    cardExpYear: number | null = null;
    gatewayId: string;
    gatewayType: PaymentGatewayType | null = null;
    gatewayName: string | null = null;

    @computed
    get hasCard() {
        return !!this.cardLastFourDigits;
    }

    @computed
    get cardNumber() {
        if (!this.hasCard) return null;
        const prefix = this.cardFirstSixDigits ? `${this.cardFirstSixDigits.substring(0, 4)} ${this.cardFirstSixDigits.substring(4)}•• ••••` : '•••• •••• ••••';
        return `${prefix} ${this.cardLastFourDigits}`;
    }

    @computed
    get expiresAt(): Moment | null {
        if (!this.cardExpMonth || !this.cardExpYear) return null;
        return moment({ year: this.cardExpYear, month: this.cardExpMonth - 1, day: 1 }).endOf('month');
    }

    @computed
    get isExpired() {
        const expiresAt = this.expiresAt;
        return !!expiresAt && expiresAt.isBefore(moment());
    }

    static fromJson(json: any): StudentPaymentMethod {
        return new StudentPaymentMethod({
            id: json.id,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined,
            updatedDate: json.updatedDate ? moment(json.updatedDate) : null,
            cardFirstSixDigits: json.cardFirstSixDigits ?? null,
            cardLastFourDigits: json.cardLastFourDigits ?? null,
            cardExpMonth: json.cardExpMonth ?? null,
            cardExpYear: json.cardExpYear ?? null,
            gatewayId: json.gatewayId,
            gatewayType: json.gatewayType ?? null,
            gatewayName: json.gatewayName ?? null
        });
    }

    @action
    update(t: Partial<StudentPaymentMethod>) {
        super.update(t);
    }

    clone() {
        return new StudentPaymentMethod({ ...this });
    }
}
